import Box from '@mui/material/Box';
import type { IconButtonProps } from '@mui/material/IconButton';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import React, { useCallback, useRef, useState } from 'react';

import { MoreVertOutlinedIcon } from '../../../icons';

export type KebabMenuProps = React.PropsWithChildren<{
  defaultOpen?: boolean;
  slotProps?: {
    button?: Pick<IconButtonProps, 'color' | 'edge' | 'aria-label'>;
  };
}>;

export const KebabMenu: React.FC<KebabMenuProps> = ({
  children,
  defaultOpen = false,
  slotProps,
}) => {
  const btnRef = useRef<HTMLButtonElement | null>(null);
  const [isOpened, setIsOpened] = useState(defaultOpen);

  const handleDropdownClick = useCallback(() => {
    setIsOpened(isOpen => !isOpen);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpened(false);
  }, []);

  return (
    <Box>
      <IconButton
        aria-label="Kebab menu button"
        {...slotProps?.button}
        ref={btnRef}
        onClick={handleDropdownClick}
      >
        <MoreVertOutlinedIcon />
      </IconButton>
      <Menu open={isOpened} onClose={handleClose} anchorEl={btnRef.current} onClick={handleClose}>
        {children}
      </Menu>
    </Box>
  );
};
